export const AVAILABLE_LANGUAGES = [
    'cs',
    'en',
] as const

export type AvailableLanguage = typeof AVAILABLE_LANGUAGES[number]

export const DEFAULT_LANGUAGE_CODE: AvailableLanguage = 'cs'

export const DEVICE_IOS = 'ios' as const
export const DEVICE_ANDROID = 'android' as const

// Same bucket as FIRESTORE_SERVICE_IMAGES_BUCKET in functions/src/shared/const.ts.
// Kept local on purpose: importing functions' const.ts would pull its generated
// files and server-only secrets into the client bundle.
export const SERVICE_IMAGES_BUCKET = 'gs://topgain-monitoring-service-images'
